import React from 'react';

const ReceiptItemRow = ({ item, onQuantityChange, onRemove }) => {
  return (
    <div className="grid grid-cols-[1.8fr_0.8fr_0.8fr_0.8fr_auto] gap-3 items-center py-3 border-b border-gray-200">
      <div className="text-lg font-medium text-gray-900">{item.name}</div>
      <div>
        <input
          type="number"
          min="1"
          value={item.quantity}
          onChange={(e) => onQuantityChange(item.id, parseInt(e.target.value, 10) || 1)}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg text-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div className="text-lg text-gray-700">{Number(item.price).toFixed(2)}</div>
      <div className="text-lg font-semibold text-gray-900">{Number(item.price * item.quantity).toFixed(2)}</div>
      <button
        type="button"
        onClick={() => onRemove(item.id)}
        className="text-red-500 hover:text-red-700 transition text-lg"
      >
        ✕
      </button>
    </div>
  );
};

export default ReceiptItemRow;
